import { Component } from 'react';
import { connect } from 'react-redux';
import { toggleAdmin } from '../actions/admin';
import { inviteeReset } from '../actions/invitee';
import { toggleKonami, toggleCode } from '../actions/shortcuts';
import { bindActionCreators } from 'redux';

const mapStateToProps = state => ({
  adminMode: state.admin.adminMode,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { toggleAdmin, inviteeReset, toggleKonami, toggleCode }, dispatch
  );
}

class Shortcuts extends Component {
  keylog = [];

  handleKeyDown(event) {
    let key = event.key;
    if (
      key.match(/[a-zA-Z0-9]/) ||
      key.toLowerCase().includes('arrow')
    ) {
      if (key === 'ArrowUp') key = 1;
      else if (key === 'ArrowDown') key = 2;
      else if (key === 'ArrowLeft') key = 3;
      else if (key === 'ArrowRight') key = 4;
      this.keylog.push(key);

      if (this.keylog.length > 20) this.keylog.shift();

      this.checkKeyCodes();
    }
  }

  checkKeyCodes() {
    if (this.keylog.slice(-5).join('') === 'admin') {
      this.props.toggleAdmin();
    } else if (this.keylog.slice(-5).join('') === 'reset') {
      this.props.inviteeReset();
    } else if (this.keylog.slice(-6).join('') === 'konami') {
      this.props.toggleKonami();
    } else if (this.keylog.slice(-4).join('') === 'code') {
      this.props.toggleCode();
    } else if (this.keylog.slice(-10).join('') === '11223434ba') {
      this.props.toggleKonami();
    }
  }

  componentWillMount() {
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
  }

  render() {
    return null;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Shortcuts);



// WEBPACK FOOTER //
// ./src/components/Shortcuts.js